import { FC, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import useSnackBars from '../../components/commons/snackbar/SnackbarHook';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: theme.spacing(3),
  },
  icon: {
    fontSize: 64,
    marginBottom: theme.spacing(2),
  },
  successIcon: {
    color: '#4caf50',
  },
  errorIcon: {
    color: theme.palette.error.main,
  },
  message: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
}));

const OutlookCallback: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { showSuccess, showError } = useSnackBars();

  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
  const [message, setMessage] = useState('Conectando con Outlook...');

  useEffect(() => {
    handleCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCallback = () => {
    const params = new URLSearchParams(location.search);
    const success = params.get('success');
    const error = params.get('error');
    const email = params.get('email');

    if (success === 'true') {
      setStatus('success');
      setMessage(email ? `Conectado como ${email}` : 'Outlook conectado exitosamente');
      showSuccess('Outlook conectado exitosamente');

      // Redirect to profile after short delay
      setTimeout(() => {
        history.push('/profile');
      }, 2000);
    } else if (error) {
      setStatus('error');
      setMessage(decodeURIComponent(error));
      showError(decodeURIComponent(error));

      // Redirect to profile after short delay
      setTimeout(() => {
        history.push('/profile');
      }, 3000);
    } else {
      // No parameters - just redirect
      history.push('/profile');
    }
  };

  return (
    <Box className={classes.container}>
      {status === 'processing' && (
        <>
          <CircularProgress size={64} />
          <Typography variant="h6" className={classes.message}>
            {message}
          </Typography>
        </>
      )}

      {status === 'success' && (
        <>
          <CheckCircleIcon className={`${classes.icon} ${classes.successIcon}`} />
          <Typography variant="h6" className={classes.message}>
            {message}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Redirigiendo...
          </Typography>
        </>
      )}

      {status === 'error' && (
        <>
          <ErrorIcon className={`${classes.icon} ${classes.errorIcon}`} />
          <Typography variant="h6" className={classes.message}>
            Error al conectar
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {message}
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            Redirigiendo...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default OutlookCallback;
